export default "__VITE_ASSET__BOsIPS6y__"